import AddIcon from "@mui/icons-material/Add";
import { Button } from "designSystem/index";
import React from "react";
import CssColumnGrid from "../../CssColumnGrid";

export default () => (
	<CssColumnGrid columns={6}>
		<Button design="primary" startIcon={<AddIcon />} />
		<Button design="primary" startIcon={<AddIcon />}>Primary</Button>
		<Button design="secondary" startIcon={<AddIcon />}>Secondary</Button>
		<Button design="outline" startIcon={<AddIcon />}>Outline</Button>
		<Button design="link" startIcon={<AddIcon />}>Link</Button>
		<Button design="linkSubtle" startIcon={<AddIcon />}>Link Subtle</Button>
	</CssColumnGrid>
);